import { useGlobalData } from "../data/GeneralData";
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

import Banner from "../components/Banner";
import RegisterCallout from "../components/RegisterCallout";
import QuoteSlider from "../components/QuoteSlider";
import WhoAttends from "../components/WhoAttends";

const SponsorLevels = () => {
  const { shortYear } = useGlobalData();

  const [activeTab, setActiveTab] = useState("platinum");
  const [tableData, setTableData] = useState({});

  const sponsorTableData = useMemo(
    () => ({
      "Conference Access": [
        [
          `FinComp '${shortYear} conference passes`,
          `3 passes\n(Everyone after half price)`,
          `2 passes\n(Everyone after half price)`,
          `1 pass\n(Everyone after half price)`,
        ],
      ],
      "Prominent Trade Show Presence": [
        [
          `One 6ft draped table for a trade show display in the Dining Room`,
          `y`,
          `y`,
          `y`,
        ],
        [`Premier placement of the trade show display`, `y`, `n`, `n`],
      ],
      "Enhanced Visibility": [
        [
          `Featured on the FinComp '${shortYear} Landing Page with a link to your website`,
          `y`,
          `y`,
          `y`,
        ],
        [
          `Recognition in all major marketing emails and surveys for FinComp '${shortYear}, accompanied by a link to your website`,
          `y`,
          `y`,
          `y`,
        ],
      ],
      "Brand Exposure": [
        [
          `Logo featured on table tent cards present during meals and general sessions`,
          `y`,
          `y`,
          `y`,
        ],
        [
          `Logo included in rotating slides displayed between all general sessions`,
          `y`,
          `y`,
          `y`,
        ],
        [
          "Logo displayed on a `Thank you to our sponsors` sign at the check-in desk",
          `y`,
          `y`,
          `y`,
        ],
      ],
      "Marketing Opportunities": [
        [
          `Sponsor-selected or template advertisement included in the FinComp '${shortYear} attendee notebook`,
          `Full-page with premier placement`,
          `Half-page\n(Upgrade to full-page for $500)`,
          `n`,
        ],
        [
          `One sponsor-produced post on all FinComp '${shortYear} social media channels`,
          `y`,
          `n`,
          `n`,
        ],
      ],
      "Networking and Engagement": [
        [`Invitation to speak on a pre-approved subject`, `y`, `n`, `n`],
        [
          `Opportunity to give a 2-minute introduction of your company`,
          `During the lunch of your choosing`,
          `During the pre-conference networking event`,
          `n`,
        ],
        [
          `Opportunity to facilitate one HR Roundtable Session with a BalancedComp consultant`,
          `y`,
          `n`,
          `n`,
        ],
        [
          `Opportunity to introduce a guest speaker at a general session using a provided script`,
          `y`,
          `y`,
          `n`,
        ],
        [
          `3-minute product presentation before or after a general session`,
          `Yes - done during 2-minute company intro\n(5 minutes total)`,
          `y`,
          `n`,
        ],
      ],
      "Exclusive Benefits": [
        [
          `A list of all FinComp '${shortYear} attendees' emails`,
          `y`,
          `y`,
          `y`,
        ],
        [
          `An opportunity to provide one Sponsor-branded item in each FinComp '${shortYear} tote bag`,
          `y`,
          `y`,
          `n`,
        ],
      ],
      "Post-Event Recognition": [
        [
          `Inclusion in all FinComp '${shortYear} video materials distributed`,
          `y`,
          `n`,
          `n`,
        ],
      ],
      "Priority for Future Involvement": [
        [
          `First chance at same-level sponsorship for the next FinComp conference`,
          `y`,
          `y`,
          `n`,
        ],
      ],
    }),
    [shortYear],
  );

  useEffect(() => {
    setTableData(sponsorTableData);
  }, [sponsorTableData]);

  const handleTabClick = (column) => {
    setActiveTab(column);
  };

  const renderTableData = (categoryData) => {
    return categoryData.map((rowData, rowIndex) => (
      <tr key={rowIndex}>
        {rowData.map((value, colIndex) => {
          let cellClass = "";
          if (colIndex === 0) cellClass = "main-col";
          else if (colIndex === 1) cellClass = "platinum-col";
          else if (colIndex === 2) cellClass = "gold-col";
          else if (colIndex === 3) cellClass = "silver-col";

          const displayValue =
            value === "y"
              ? ' <i class="fa fa-check-circle"></i>'
              : value === "n"
                ? ' <i class="fa fa-ban"></i>'
                : value.replace(/\n/g, "<br />");

          return (
            <td
              key={colIndex}
              className={`${cellClass} ${
                activeTab === "platinum" && colIndex === 1 ? "show-col" : ""
              } ${activeTab === "gold" && colIndex === 2 ? "show-col" : ""} ${
                activeTab === "silver" && colIndex === 3 ? "show-col" : ""
              }`}
              dangerouslySetInnerHTML={{ __html: displayValue }}
            />
          );
        })}
      </tr>
    ));
  };

  return (
    <>
      <Banner
        leftImage="img/bg-banner-round-gradient.webp"
        className="bg-after-purple"
      >
        <div className="col-12 mb-3">
          <div className="display-1 color-white">Sponsorship Opportunities</div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-5">
            As a FinComp sponsor, you have complete access to all educational
            sessions, meals, and events. We encourage you to meet, network, and
            learn with attendees to understand their challenges and successes
            firsthand.
          </p>
        </div>
        <div className="col-12">
          <Link to="/SponsorForm" className="btn-white-o">
            Become a Sponsor
          </Link>
        </div>
      </Banner>
      <section id="sponsor-levels" className="bg-purple bg-after-purple">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="sponsor-tabs">
                {["platinum", "gold", "silver"].map((level) => (
                  <div
                    key={level}
                    className={`tab tab-${level} ${
                      activeTab === level ? "tab-active" : ""
                    }`}
                    data-column={level}
                    onClick={() => handleTabClick(level)}
                  >
                    <h4>{level.charAt(0).toUpperCase() + level.slice(1)}</h4>
                  </div>
                ))}
              </div>

              <table id="sponsorTable" className="sponsor-level-table">
                <thead className="sponsor-header">
                  <tr>
                    <th></th>
                    <th width="20%" className="text-center">
                      <h2>Platinum</h2>
                    </th>
                    <th width="20%" className="text-center">
                      <h2>Gold</h2>
                    </th>
                    <th width="20%" className="text-center">
                      <h2>Silver</h2>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span className="color-white">Price</span>
                    </td>
                    <td
                      className={`platinum-col ${activeTab === "platinum" ? "show-col" : ""}`}
                    >
                      <span className="color-white">$15,000</span>
                    </td>
                    <td
                      className={`gold-col ${activeTab === "gold" ? "show-col" : ""}`}
                    >
                      <span className="color-white">$5,500</span>
                    </td>
                    <td
                      className={`silver-col ${activeTab === "silver" ? "show-col" : ""}`}
                    >
                      <span className="color-white">$2,500</span>
                    </td>
                  </tr>
                </tbody>
                {Object.keys(tableData).map((category) => (
                  <React.Fragment key={category}>
                    <thead>
                      <tr className="category-header">
                        <th colSpan={4}>
                          <strong>{category}</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>{renderTableData(tableData[category])}</tbody>
                  </React.Fragment>
                ))}
              </table>
            </div>
          </div>
        </div>
      </section>

      <QuoteSlider className="bg-purple-before bg-purple-after" />
      <WhoAttends />
      <RegisterCallout className="bg-before-purple" />
    </>
  );
};

export default SponsorLevels;
